"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const element_1 = require("../types/element");
function defaultAudio() {
    return {
        id: (0, nanoid_1.nanoid)(8),
        type: element_1.ELEMENT_TYPE.AUDIO,
        playing: false,
        name: '',
        fileType: '',
        src: '',
        captioning: false,
        duration: 0,
        genre: '',
        mediaId: '',
        audioAttenuation: undefined,
        volume: 1,
        fadeOut: false,
        fadeIn: false,
        textToSpeech: '',
        audioType: undefined,
        textToSpeechConfig: undefined,
    };
}
exports.default = defaultAudio;
